import {module} from 'angular';

export default module('app.constants.app-name', []).constant('appName', 'sofe');
